import React from 'react';

export default function TicketSelector({ tier, quantity, onUpdate, disableIncrease }) {
  const available = tier.capacity - tier.sold;
  const formatCurrency = (amount) =>
    new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount);

  return (
    <div
      data-testid={`ticket-tier-${tier.id}`}
      className="bg-white border border-gray-100 rounded-2xl p-4 shadow-sm"
    >
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 data-testid={`ticket-tier-name-${tier.id}`} className="font-bold text-[#2B3A67]">
            {tier.name}
          </h3>
          <p data-testid={`ticket-tier-available-${tier.id}`} className="text-xs text-gray-500">
            {available} tickets available
          </p>
        </div>
        <div className="text-right">
          <p data-testid={`ticket-tier-price-${tier.id}`} className="text-lg font-bold text-[#2B3A67]">
            {tier.price === 0 ? 'Free' : formatCurrency(tier.price)}
          </p>
        </div>
      </div>

      {available > 0 ? (
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              data-testid={`decrease-${tier.id}`}
              onClick={() => onUpdate(tier.id, -1)}
              disabled={quantity === 0}
              className="rounded-full h-8 w-8 border-2 border-gray-200 text-[#2B3A67] font-bold"
            >
              -
            </button>
            <span
              data-testid={`quantity-${tier.id}`}
              className="font-semibold w-8 text-center text-[#2B3A67]"
            >
              {quantity}
            </span>
            <button
              data-testid={`increase-${tier.id}`}
              onClick={() => onUpdate(tier.id, 1)}
              disabled={quantity >= available || disableIncrease}
              className="rounded-full h-8 w-8 border-2 border-gray-200 text-[#2B3A67] font-bold"
            >
              +
            </button>
          </div>
          <p data-testid={`ticket-tier-subtotal-${tier.id}`} className="text-sm font-bold text-[#2B3A67]">
            {quantity > 0 && formatCurrency(tier.price * quantity)}
          </p>
        </div>
      ) : (
        <p data-testid={`ticket-tier-soldout-${tier.id}`} className="text-sm text-[#E54562] font-bold">
          Sold Out
        </p>
      )}
    </div>
  );
}